import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { OcaenFreightRatesEntity } from "./ocean-freights-entity";
import { OcaenFreightRateLogsEntity } from "./ocaen-freight-rates-log-entity";
import { OcaenFreightRateService } from "./ocaen-freight-rates-service";
import { OcaenFreightRatesController } from "./ocaen-freight-rates-controller";


@Module({
    imports:[
        TypeOrmModule.forFeature([OcaenFreightRatesEntity,OcaenFreightRateLogsEntity])
    ],
    providers:[OcaenFreightRateService,ApplicationExceptionHandler],
    controllers:[OcaenFreightRatesController],
    exports:[OcaenFreightRateService]
})
export class OcaenFreightRateModule{}